import { Component } from "react";
import ServicioAutorizaciones from "../../../servicios/Autorizaciones";
import { __MaximoCaracteresIdentificacion } from "../../../Utils/Funciones";
import { CerrarNotificador, Notificar } from "../../Comunes/Notificador";
import ParametroConsultaRevocatorias from "../../../Contenedores/Autorizaciones/ParametroConsultaRevocatorias";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "bootstrap/dist/css/bootstrap.min.css";
import es from "date-fns/locale/es"; // the locale you want
import InputMask from "react-input-mask";
import ResultadoConsulta from "./ResultadoConsultaRevocatoria";
import DetalleRevocacion from "./DetalleRevocacion";
import TipoPersonaDropdown from "../../Comunes/Dropdowns/TiposPersona/TipoPersonaDropdown";
import PageHeading from "../../Comunes/PageHeading";

registerLocale("es", es);
export class ParametrosConsultaRevocatorias extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ListaUsuarioTramite: [],
      identificacion: "",
      seleccionTipoPersona: "0",
      seleccionUsuarioTramite: "0",
      MaximoCaracteres: 9,
      fechaDesde: null,
      fechaHasta: null,
      resultadoConsulta: [],
      parametrosCargados: [],
      numeroRevocacion: "",
      DatosParaDetalle: [],
      //Parametros de ocultar o mostrar información a nivel de resultado y detalle autorización
      mostrarDatatable: false,
      MostrarComponenteResultados: false,
      OcultarParametrosBusqueda: false,
      MostrarDetalleConsulta: false,
    };

    this._onSeleccionTipoPersona = this._onSeleccionTipoPersona.bind(this);
    this._fechaDesdeSeleccionada = this._fechaDesdeSeleccionada.bind(this);
    this._fechaHastaSeleccionada = this._fechaHastaSeleccionada.bind(this);
    this._ConsulteRevocaciones = this._ConsulteRevocaciones.bind(this);
    this._onSeleccionUsuarioTramite =
      this._onSeleccionUsuarioTramite.bind(this);
    this._ObtengaIdentificacion = this._ObtengaIdentificacion.bind(this);
    this._ObtengaNumeroRevocacion = this._ObtengaNumeroRevocacion.bind(this);
    this._CargarDetalles = this._CargarDetalles.bind(this);
    this._volverAParametrosConsulta =
      this._volverAParametrosConsulta.bind(this);
    this.limpiarFiltros = this.limpiarFiltros.bind(this);
  }

  async componentDidMount() {
    await this.ObtengaCombobox();
  }

  async ObtengaCombobox() {
    let Usuarios =
      await ServicioAutorizaciones.ObtengaUsuariosTramiteRevocatorias();
    this.setState({
      ListaUsuarioTramite: Usuarios,
    });
  }

  async _onSeleccionTipoPersona(e) {
    let valor = e.target.value;
    let max = await __MaximoCaracteresIdentificacion(valor);

    this.setState({
      MaximoCaracteres: max,
      seleccionTipoPersona: valor,
    });
  }

  async _onSeleccionUsuarioTramite(e) {
    this.setState({
      seleccionUsuarioTramite: e.target.value,
    });
  }

  async _ObtengaIdentificacion({ target: { value } }) {
    this.setState({
      identificacion: value,
    });
  }
  async _ObtengaNumeroRevocacion({ target: { value } }) {
    this.setState({
      numeroRevocacion: value.replace("-", ""),
    });
  }
  async maskIdentificacion(v) {
    let digitos = !v ? "" : v.replace(/[^\d]/g, "");
    if (digitos.length > this.state.MaximoCaracteres) {
      digitos = v.substring(0, this.state.MaximoCaracteres);
      this.setState({ identificacion: digitos });
    }
    return digitos;
  }

  async _fechaDesdeSeleccionada(date) {
    this.setState({
      fechaDesde: date !== null ? date : null,
    });
  }

  async _fechaHastaSeleccionada(date) {
    this.setState({
      fechaHasta: date !== null ? date : null,
    });
  }

  cargarParametrosConsulta() {
    let parametro = new ParametroConsultaRevocatorias();
    let numeroRevocacion = this.state.numeroRevocacion;
    parametro.Identificacion =
      this.state.identificacion === "" ? null : this.state.identificacion;
    parametro.TipoPersona =
      this.state.seleccionTipoPersona === "0"
        ? null
        : this.state.seleccionTipoPersona;
    parametro.FechaTramiteDesde = this.state.fechaDesde;
    parametro.FechaTramiteHasta = this.state.fechaHasta;
    parametro.NumeroRevocacion =
      numeroRevocacion === "" ? null : numeroRevocacion;
    parametro.UsuarioTramiteIdentificacion =
      this.state.seleccionUsuarioTramite === "0"
        ? null
        : this.state.seleccionUsuarioTramite;
    return parametro;
  }

  limpiarFiltros = () => {
    this.setState({
      identificacion: "",
      seleccionTipoPersona: "0",
      seleccionUsuarioTramite: "0",
      fechaDesde: null,
      fechaHasta: null,
      numeroRevocacion: "",
    });
  };

  async _ConsulteRevocaciones() {
    let parametros = this.cargarParametrosConsulta();
    var consulta = await ServicioAutorizaciones.ConsultaRevocaciones(
      parametros
    );
    if (consulta.esValido) {
      this.setState({
        resultadoConsulta: consulta.listaRevocaciones,
        MostrarComponenteResultados: true,
        parametrosCargados: parametros,
        UnaVez: false,
        MostrarDetalleConsulta: false,
        mostrarDatatable: true,
      });
      CerrarNotificador();
    } else {
      Notificar("error", consulta.errores);
    }
  }

  async _CargarDetalles(datos) {
    this.setState({
      OcultarParametrosBusqueda: true,
      MostrarDetalleConsulta: true,
      mostrarDatatable: false,
      DatosParaDetalle: datos,
    });
  }

  async _volverAParametrosConsulta() {
    this.setState({
      OcultarParametrosBusqueda: false,
      MostrarDetalleConsulta: false,
      mostrarDatatable: true,
    });

    await this._ConsulteRevocaciones();
  }

  render() {
    return (
      <div>
        {this.state.OcultarParametrosBusqueda === false ? (
          <>
            <PageHeading title="Consulta de Revocatorias" />
            <div className="card shadow mb-4">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-4">
                    <div className="card mb-4">
                      <div className="card-header">
                        <h6 className="m-0 font-weight-bold text-primary">
                          Datos de la Persona
                        </h6>
                      </div>
                      <div className="card-body">
                        <div className="form-group row">
                          <div className="col-md-3 col-form-label">
                            <label htmlFor="TipoPersonaA"> Tipo Persona</label>
                          </div>
                          <div className="col-md-9">
                            <TipoPersonaDropdown
                              id="TipoPersonaA"
                              className="form-control"
                              value={this.state.seleccionTipoPersona}
                              onChange={(e) => this._onSeleccionTipoPersona(e)}
                              permiteSeleccionarValorDefault="true"
                            />
                          </div>
                        </div>
                        <div className="form-group row ">
                          <div className="col-md-3 col-form-label">
                            <label htmlFor="IdentificacionID">
                              {" "}
                              Identificación
                            </label>
                          </div>
                          <div className="col-md-9">
                            <InputMask
                              mask={this.maskIdentificacion(
                                this.state.identificacion
                              )}
                              maskChar=""
                              placeholder="Identificación"
                              value={this.state.identificacion}
                              id="IdentificacionID"
                              className="form-control"
                              onChange={this._ObtengaIdentificacion}
                              autoComplete="off"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-2">
                    <div className="card mb-4">
                      <div className="card-header">
                        <h6 className="m-0 font-weight-bold text-primary">
                          Fecha del Trámite
                        </h6>
                      </div>
                      <div className="card-body">
                        <div className="form-group row">
                          <div className="col-md-3 col-form-label">
                            <label htmlFor="FechaTramiteDesde"> Desde</label>
                          </div>
                          <div className="col-md-9">
                            <DatePicker
                              id="FechaTramiteDesde"
                              locale="es"
                              selected={this.state.fechaDesde}
                              onChange={this._fechaDesdeSeleccionada}
                              dateFormat="dd/MM/yyyy"
                              className="form-control"
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="form-group row">
                          <div className="col-md-3 col-form-label">
                            <label htmlFor="FechaTramiteHasta">Hasta</label>
                          </div>
                          <div className="col-md-9">
                            <DatePicker
                              id="FechaTramiteHasta"
                              locale="es"
                              selected={this.state.fechaHasta}
                              onChange={this._fechaHastaSeleccionada}
                              dateFormat="dd/MM/yyyy"
                              className="form-control"
                              autoComplete="off"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="card mb-4">
                      <div className="card-header">
                        <h6 className="m-0 font-weight-bold text-primary">
                          Datos de la Revocación
                        </h6>
                      </div>
                      <div className="card-body">
                        <div className="form-group row">
                          <div className="col-md-3 col-form-label">
                            <label htmlFor="NumeroRevocacion">
                              No. Revocación
                            </label>
                          </div>
                          <div className="col-md-9">
                            <InputMask
                              mask="R99999999-9999"
                              maskChar=""
                              placeholder="RXXXXXXXX-XXXX"
                              value={this.state.numeroRevocacion}
                              id="NumeroRevocacion"
                              className="form-control"
                              onChange={this._ObtengaNumeroRevocacion}
                            />
                          </div>
                        </div>
                        <div className="form-group row">
                          <div className="col-md-3 col-form-label">
                            <label htmlFor="UsuarioTramite">
                              Usuario Trámite
                            </label>
                          </div>
                          <div className="col-md-9">
                            <select
                              id="UsuarioTramite"
                              className="form-control"
                              value={this.state.seleccionUsuarioTramite}
                              onChange={(e) =>
                                this._onSeleccionUsuarioTramite(e)
                              }
                            >
                              <option value="0">Todos</option>
                              {this.state.ListaUsuarioTramite.map((item) =>
                                item != null ? (
                                  <option
                                    key={item.identificacion}
                                    value={item.identificacion}
                                  >
                                    {item?.nombrePersona}
                                  </option>
                                ) : null
                              )}
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-12">
                    <button
                      id="btnBuscarRevocaciones"
                      type="button"
                      onClick={this._ConsulteRevocaciones}
                      className="btn btn-primary btn-icon-split cBtnBuscarRevocaciones"
                    >
                      <span className="icon text-white-50">
                        <i className="fas fa-search"></i>
                      </span>
                      <span className="text">Buscar</span>
                    </button>

                    <button
                      id="btnLimpiarFiltros"
                      onClick={this.limpiarFiltros}
                      type="button"
                      className="btn btn-sm btn-light ml-3"
                    >
                      <i className="fas fa-redo fa-sm mr-1"></i>
                      Limpiar filtros
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : null}

        {this.state.MostrarComponenteResultados ? (
          <ResultadoConsulta
            datos={this.state.resultadoConsulta}
            parametrosCargados={this.state.parametrosCargados}
            mostrarDatatable={this.state.mostrarDatatable}
            _CargarDetalles={this._CargarDetalles.bind(this)}
          />
        ) : null}

        <div>
          {this.state.MostrarDetalleConsulta ? (
            <DetalleRevocacion
              DatosRevocacion={this.state.DatosParaDetalle}
              VolverAResultados={this._volverAParametrosConsulta.bind(this)}
            />
          ) : null}
        </div>
      </div>
    );
  }
}

export default ParametrosConsultaRevocatorias;
